module.exports = __webpack_public_path__ + "img/logo_TAIPING.27f14674.png";